import { render, staticRenderFns } from "./NewExpense.vue?vue&type=template&id=5cca6f84"
import script from "./NewExpense.vue?vue&type=script&lang=js"
export * from "./NewExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports